
export const rts = {
  ammendFavorites: 'ammendFavorites',
}

export const favoritesInitialState = (initState) => {
  return { ...initState }
};

export const favoritesReducer = (state, action) => {

  const { type } = action

  switch (type) {
    case rts.ammendFavorites:
      return { ...state, appUserFavs: action.appUserFavs }

    default:
      return state
  }
}

export const favoritesHandlers = (dispatch) => {

  return {
    ammendFavorites: (appUserFavs) => { dispatch({ type: rts.ammendFavorites, dispatch, appUserFavs }) },
  }
}

